function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import React, { Fragment, useMemo } from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { Title } from '../Title/Title';
import { Tooltip } from '../Tooltip/Tooltip';
import { AdvertiserDisclosureMessage, PRODUCT_TYPES } from './AdvertiserDisclosureMessage';
import styles from './AdvertiserDisclosure.module.less';
export var AdvertiserDisclosure = function AdvertiserDisclosure(_ref) {
  var onBackground = _ref.onBackground,
      type = _ref.type,
      enableAnalytics = _ref.enableAnalytics,
      children = _ref.children,
      color = _ref.color,
      label = _ref.label,
      shouldDelay = _ref.shouldDelay;
  useDeprecatedPropsWarning({
    component: 'AdvertiserDisclosure',
    deprecatedProps: [{
      deprecated: 'children',
      migration: 'Use the type prop to render the standard, compliance-approved message for your product type.',
      version: '5.6.0'
    }, {
      deprecated: 'color',
      migration: 'All components will have the same blue color.',
      version: '5.5.0'
    }, {
      deprecated: 'label',
      migration: "All components will have the same default label, 'Advertiser disclosure.'",
      version: '5.5.0'
    }, {
      deprecated: 'shouldDelay',
      migration: 'AdvertiserDisclosure no longer hovers.  It is a toggle tip (<Tooltip />). As a result, delayed toggling of visibility on hover events is not possible.',
      version: '5.13.0'
    }],
    props: {
      children: children,
      color: color,
      label: label,
      shouldDelay: shouldDelay
    }
  }); // tooltip analytics configuration

  var analytics = useMemo(function () {
    return enableAnalytics && {
      entityName: 'advertiser_disclosure'
    };
  }, [enableAnalytics]);
  return /*#__PURE__*/React.createElement(Tooltip, {
    id: "advertiser-disclosure-popover" // TODO: can we change this to "advertiser-disclosure"?
    ,
    "aria-label": "Advertiser Disclosure",
    analytics: analytics,
    className: classNames(styles['ad-trigger'], _defineProperty({}, styles['on-background'], onBackground)),
    content: /*#__PURE__*/React.createElement("div", {
      className: classes(['text-default', 'color-neutral-darkest', 'max-width-prose-narrow', 'max-width-prose-wide--wide'])
    }, children || /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Title, {
      className: classes('margin-bottom-3'),
      color: "green",
      size: "medium"
    }, "You\u2019re our first priority.", /*#__PURE__*/React.createElement("br", null), "Every time."), /*#__PURE__*/React.createElement(AdvertiserDisclosureMessage, {
      type: type
    })))
  }, label || 'Advertiser disclosure');
};
AdvertiserDisclosure.defaultProps = {
  onBackground: false,
  type: PRODUCT_TYPES.CREDIT_CARDS
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  AdvertiserDisclosure.propTypes = {
    /**
     * Flag to enable bedrock analytics tracking. The shape is legacy. only truthiness of prop is checked now.
     */
    enableAnalytics: PropTypes.oneOfType([PropTypes.bool, // leaving this in to prevent propType warnings
    PropTypes.shape({
      onClick: PropTypes.bool,
      onHover: PropTypes.bool
    })]),

    /**
     * As of v5.6 allowing custom text or elements to render
     * within the Popover will not be supported. See Changelog for details.
     * @deprecated
     */
    children: PropTypes.node,

    /**
     * As of v5.5 changing link color will not be possible. See Changelog for details.
     * @deprecated
     */
    color: PropTypes.string,

    /**
     * As of v5.5 changing label will not be supported. See Changelog for details.
     * @deprecated
     */
    label: PropTypes.string,

    /**
     * Flag to indicate if component is not on a white background.
     */
    onBackground: PropTypes.bool,

    /**
     * Now a no-op. Flag to set a longer delay on the appearance of the Popover.
     * @deprecated
     */
    shouldDelay: PropTypes.bool,

    /**
     * String to indicate which type of advertiser disclosure message to render. Stems from the
     * canoncial marketplace PRODUCT_TYPE fields. Currently
     * supports
     *
     * 0) credit_cards (default)
     * 1) investing
     *
     * More types can be added as needed.
     */
    type: PropTypes.oneOf([PRODUCT_TYPES.CREDIT_CARDS, PRODUCT_TYPES.INVESTING])
  };
}

export { PRODUCT_TYPES };